import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonSettings } from 'epay-library';
import { lastValueFrom, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppLoadService {
  constructor(private httpClient: HttpClient) {}

  async getParameterSettings(): Promise<any> {
    let apiCmd = 'parameters';
    let gateway = 'v1/';

    const obsParameterValue = this.httpClient
      .get<any>(CommonSettings.BaseApi + gateway + apiCmd, {
        headers: new HttpHeaders({
          'x-client-id': CommonSettings.ClientID,
          'x-environment': CommonSettings.Environment
        }),
      })
      .pipe(
        map((parameterValues: any) => {
          CommonSettings.NumOfDaysForPaymentHistory =
            parameterValues.EPay_NumOfDaysForPaymentHistory;
          CommonSettings.NumOfDaysOutForCalendar =
            parameterValues.EPay_NumOfDaysOutForCalendar;
          CommonSettings.DaysToShowEFTFileHistory =
            parameterValues.EPay_DaysToShowEFTFileHistory;
          CommonSettings.Timezone = parameterValues.EPay_ClientTimeZone;
          CommonSettings.EmpWebsiteCode = parameterValues.EPay_EmpWebsiteCode;
          CommonSettings.AppInsightsConnectionString = parameterValues.EPay_AppInsightConnectionString;
          CommonSettings.AppInsightsEnableAutoRouteTracking = parameterValues.EPay_AppInsightEnableAutoRouteTracking;
          CommonSettings.CreditCardVendorID =
            parameterValues.EPay_CreditCardVendorID;
          CommonSettings.FortPointAccessToken =
            parameterValues.EPay_FortPointAccessToken;
          CommonSettings.FortPointCreditCardUrl =
            parameterValues.EPay_FortPointCreditCardUrl;
          CommonSettings.FortPointStateCode =
            parameterValues.EPay_FortPointStateCode;
          CommonSettings.ChatUrl = parameterValues.EPay_Chat_url;
          return parameterValues;
        }),
        catchError(this.handleError)
      );

    return await lastValueFrom(obsParameterValue);
  }

  async getConfigSettings(): Promise<any> {
    //Get settings from config file
    const configSettings = this.httpClient
      //.get<any>('/assets/config/config.json')
      .get<any>('/tribal/assets/config/config.json')
      .pipe(
        map((configs: any) => {
          CommonSettings.Title = configs.title;
          CommonSettings.BaseApi = configs.baseApi;
          CommonSettings.ClientID = configs.clientID.toString();
          CommonSettings.Environment = configs.environment;
          return configs;
        }),
        catchError(this.handleError)
      );

    return await lastValueFrom(configSettings);
  }

  toBoolean(value: string): boolean {
    if (value === 'true')
      return true;
    else
      return false;
  }

  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An Error Occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
      console.log('Error Occurred: ' + errorMessage);
    }
    return throwError(() => err);
  }
}
